module.exports = __webpack_public_path__ + "static/img/6.c8b5432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/6.png
// module id = 32BD
// module chunks = 0